module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-right-hover-tiny.ff940b92.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-right-hover-tiny.png
// module id = 2649
// module chunks = 11